import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {getLanguage, setLanguage} from '../../reducers/configSlice';
import { STORAGE } from '../storage';
import * as i18n from '../../../i18n';

const useLanguageUpdate = (config) => {
    const dispatch = useDispatch();
    const language = useSelector(getLanguage);

    useEffect(() => {
        if (config && config.language !== language) {
            (async () => {
                await STORAGE.set('language', config.language);
                dispatch(setLanguage(config.language));
                i18n.setI18nConfig(config.language);
            })();
        }
    }, [config, language, dispatch]);
};

export default useLanguageUpdate;
